<template>
  <main>
    <div class="certified-courses">
      <div class="section-frame">
        <ul class="breadcrumbs">
          <li>
            <router-link to="/"><i class="fa-home-line"></i></router-link>
          </li>
          <li><i class="fa-arrow-next"></i></li>
          <li>
            <router-link to="/attestations">{{ $t("attestation") }}</router-link>
          </li>
        </ul>
        <div class="page-sub-title jcc certified-sub-title">
          <h1>
            <i class="fa-title"></i><i>{{ $t("attestation") }}</i>
          </h1>
        </div>
        <div class="certified-courses-title">
          <p>{{ $t("attestation_description") }}</p>
        </div>

        <p class="empty" v-if="attestations && attestations.count === 0">
          {{ $t("attestation_empty") }}
        </p>

        <div class="courses-list courses-list-ser" v-if="attestations">
          <div
            class="certified__card"
            v-for="item in attestations.results"
            :key="item.id"
          >
            <div
              class="courses-item-status"
              :class="item.is_completed ? 'status-finish' : 'status-new'"
            >
              <span>{{
                item.is_completed ? $t("passed") : $t("not_passed")
              }}</span>
            </div>
            <div class="certified__card-body">
              <h3>{{ item.name }}</h3>
              <div
                class="certified__card-text"
                v-if="item.description"
                v-html="$processHtml(item.description)"
              ></div>
              <p class="certified__card-score" v-if="item.is_completed">
                {{ $t("your_score") }}: {{ item.score }}%
              </p>
              <div class="certified__card-buttons" v-if="item.quiz_slug">
                <button
                  @click.prevent="
                    $router.push(`/attestation-test/${item.quiz_slug}`)
                  "
                >
                  {{ item.is_completed ? $t("retake") : $t("start_test") }}
                </button>
              </div>
              <p class="empty" v-else>{{ $t("attestation_no_quiz") }}</p>
            </div>
          </div>
        </div>

        <loading v-if="!attestations" />
      </div>
    </div>
  </main>
</template>

<script>
import Loading from "@/components/loading";

export default {
  name: "Attestations",
  components: { Loading },
  async mounted() {
    await this.$store.dispatch("getAttestations");
  },
  computed: {
    attestations() {
      return this.$store.getters.getAttestations;
    },
  },
};
</script>
